var styles = [".clr-select-wrapper[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:not(button){font-size:.7rem}.fake-label[_ngcontent-%COMP%]{line-height:4rem;font-size:.7rem;font-weight:600;padding-left:0}"];
export { styles as styles };
